export async function loadScript(
  src: string,
  {
    scriptId = '',
    insertBeforeAllTags = false,
    defer = false,
    type = null,
  }: {
    scriptId?: string;
    insertBeforeAllTags?: boolean;
    defer?: boolean;
    type?: string | null;
  } = {}
): Promise<void> {
  await new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = scriptId;
    script.onload = () => {
      resolve();
    };
    script.onerror = event => {
      if (event instanceof Event) {
        reject(new ExternalScriptError((event.target as HTMLScriptElement).src));
      }
    };
    script.src = src;
    if (defer) script.defer = true;
    if (type) script.type = type;

    if (insertBeforeAllTags) {
      const firstScriptTagInDocument = document.getElementsByTagName('script')[0];
      firstScriptTagInDocument?.parentNode?.insertBefore(script, firstScriptTagInDocument);
    } else {
      document.body.appendChild(script);
    }
  });
}

export class ExternalScriptError extends Error {
  url: string;

  constructor(url: string) {
    const message = `Failed to load script at ${url}`;
    super(message);
    this.name = 'ExternalScriptError';
    this.url = url;
  }
}
